import type { ApiResponse } from '../ApiResponse'

interface HtttpErrorOptions<T> {
  readonly response: ApiResponse<T>
}

class HttpError<T> extends Error {
  public readonly response?: ApiResponse<T>

  constructor(message: string, options: HtttpErrorOptions<T>) {
    super(message)
    this.name = 'HttpError'
    this.response = options.response
  }
}

export { HttpError }
